import {useEffect, useState} from 'react'
import {DICAS} from '../dicas'

interface Props {
    titulo?: string
}

/** Spinner + dica rotativa (troca a cada ~5s, com fade). Usado nas esperas
 * (busca ao vivo no PNCP, geração da justificativa) no lugar de texto técnico. */
export default function DicasLoading({titulo = 'Carregando…'}: Props) {
    const [i, setI] = useState(() => Math.floor(Math.random() * DICAS.length))
    const [on, setOn] = useState(true)

    useEffect(() => {
        const t = setInterval(() => {
            setOn(false)
            setTimeout(() => {
                setI((p) => (p + 1) % DICAS.length)
                setOn(true)
            }, 350)
        }, 5200)
        return () => clearInterval(t)
    }, [])

    return (
        <div className="lg-empty">
            <div className="dica-spinner" aria-hidden="true" />
            <div className="lg-empty__title">{titulo}</div>
            <div className={`dica${on ? ' dica--on' : ''}`}>
                <span className="dica__tag">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18h6"/><path d="M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 .9 1 1.8v.5h6v-.5c0-.9.4-1.3 1-1.8A7 7 0 0 0 12 2Z"/></svg>
                    Você sabia?
                </span>
                <span className="dica__txt">{DICAS[i]}</span>
            </div>
        </div>
    )
}
